<template>
  <div>
    <title-edit header="News" />
    <line-hr />
    <div class="row">
      <v-col cols="12" sm="3"  class="label">
        &nbsp;
      </v-col>
      <v-col cols="12" sm="8"  xs="12">
        <v-app class="switch-app">
          <v-switch label="Publish" v-model="form.is_publish"></v-switch>
        </v-app>
      </v-col>
    </div>
    <div class="row">
      <v-col cols="12" sm="3"  class="label">
        <label>orders* :</label>
      </v-col>
      <v-col cols="12" sm="8"  xs="12">
        <input-text-field :model="form.orders" @update="updateOrders"/>
      </v-col>
    </div>
    <div class="row">
      <v-col cols="12" sm="3"  class="label">
        <label>Branch :</label>
      </v-col>
      <v-col cols="12" sm="8"  xs="12">
        <select-option :items="optionBranch" :model="form.branch_id" @update="updateBranch"/>
      </v-col>
    </div>
    <div class="row">
      <v-col cols="12" sm="3"  class="label">
        <label>Title TH* :</label>
      </v-col>
      <v-col cols="12" sm="8"  xs="12">
        <input-text-field :model="form.title_th" @update="updateTitleTH"/>
      </v-col>
    </div>
    <div class="row">
      <v-col cols="12" sm="3"  class="label">
        <label>Title EN* :</label>
      </v-col>
      <v-col cols="12" sm="8"  xs="12">
        <input-text-field :model="form.title_en" @update="updateTitleEN"/>
      </v-col>
    </div>
    <div class="row">
      <v-col cols="12" sm="3"  class="label">
        <label>Description TH* :</label>
      </v-col>
      <v-col cols="12" sm="8"  xs="12">
        <input-editor :model="form.description_th" @update="updateDescriptionTH"/>
      </v-col>
    </div>
    <div class="row">
      <v-col cols="12" sm="3"  class="label">
        <label>Description EN* :</label>
      </v-col>
      <v-col cols="12" sm="8"  xs="12">
        <input-editor :model="form.description_en" @update="updateDescriptionEN"/>
      </v-col>
    </div>
    <div class="row">
      <v-col cols="12" sm="3"  class="label">
        <label>Slug Url :</label>
      </v-col>
      <v-col cols="12" sm="8"  xs="12">
        <input-text-field :model="form.slug_url" @update="updateSlugUrl" />
      </v-col>
    </div>
    <div class="row">
      <v-col cols="12" sm="3"  class="label">
        <label>Image name :</label>
      </v-col>
      <v-col cols="12" sm="8"  xs="12">
        <input-text-field :model="form.image_name" @update="updateImageName"/>
      </v-col>
    </div>
    <div class="row">
      <v-col cols="12" sm="3"  class="label">
        <label>Image :</label>
      </v-col>
      <v-col cols="12" sm="8"  xs="12">
        <input-image-upload id="image1" :model="form.image_path_show" @update="updateImage"/>
      </v-col>
    </div>
    <div class="row">
      <v-col cols="12" sm="3"  class="label">
        <label>Publish date* :</label>
      </v-col>
      <v-col cols="12" sm="8"  xs="12">
        <date-picker :model="form.publish_date" @update="updatePublishDate"/>
      </v-col>
    </div>
    <line-hr />
    <div class="row text-right">
      <v-spacer></v-spacer>
      <delete-button @click.native="deleteNews"/>
      <preview-button />
      <save-button @click.native="saveNews"/>
    </div>
  </div>
</template>

<script>
    import TitleEdit from "../../../components/TitleHeader/TitleEdit";
    import LineHr from "../../../components/Icon/line-hr";
    import DeleteButton from "../../../components/Button/DeleteButton";
    import PreviewButton from "../../../components/Button/PreviewButton";
    import SaveButton from "../../../components/Button/SaveButton";
    import SelectOption from "../../../components/Input/selectOption";
    import InputTextField from "../../../components/Input/InputTextField";
    import InputImageUpload from "../../../components/Input/InputImageUpload";
    import DatePicker from "../../../components/Input/DatePicker";
    import {mapState} from "vuex";
    import InputEditor from "../../../components/Input/InputEditor";
    export default {
        name: "NewsEdit",
      components: {
        InputEditor,
        DatePicker,
        InputImageUpload,
        InputTextField,
        SelectOption, SaveButton, PreviewButton,
        DeleteButton, LineHr, TitleEdit},
      computed: {
        ...mapState({
          form: state => {
            return state.News.form;
          }
        })
      },
      created() {
          this.getBranchData();
      },
      data(){
        return{
          optionBranch : [],
        }
      },
      methods:{
        getBranchData() {
          this.$store.dispatch("Branch/getBranchAll").then(res => {
            this.optionBranch = [
              { text: "Select", value: "" },
              ...res.map(type => ({
                value: type.branch_id,
                text: type.branch_name_th + " (" + type.branch_name_en + ")"
              }))
            ];
          });
        },
        saveNews(){
          this.$store.dispatch("News/saveNews",{
            id : this.form.news_id,
            data : this.form
          }).then(res=>{
            alert(res.response_msg);
            if(res.response_code){
              this.goToNewsTable();
            }
          }).catch(()=>{
            alert('cannot save news data');
          })
        },
        deleteNews(){
          this.$store.dispatch("News/deleteNews",this.form.news_id).then(res=>{
            alert(res.response_msg);
            if(res.response_code){
              this.goToNewsTable();
            }
          }).catch(()=>{
            alert('cannot delete news data');
          })
        },
        goToNewsTable(){
          this.$router.push("/about/news");
        },
        updateBranch(val){
          this.form.branch_id = val;
        },
        updateTitleTH(val){
          this.form.title_th = val;
        },
        updateTitleEN(val){
          this.form.title_en = val;
        },
        updateDescriptionTH(val){
          this.form.description_th = val;
        },
        updateDescriptionEN(val){
          this.form.description_en = val;
        },
        updateImage(val){
          this.form.image_path = val.imagePath;
          this.form.image_path_show = val.fullImagePath;
        },
        updateImageName(val){
          this.form.image_name = val;
        },
        updatePublishDate(val){
          this.form.publish_date = val;
        },
        updateViewer(val){
          this.form.viewer = val;
        },
        updateSlugUrl(val){
          this.form.slug_url = val;
        },
        updateOrders(val){
          this.form.orders = val;
        },
      }
    }
</script>

<style scoped>

</style>
